import { render } from "./ConsumptionGauges.vue?vue&type=template&id=530b8367&scoped=true"
import script from "./ConsumptionGauges.vue?vue&type=script&lang=js"
export * from "./ConsumptionGauges.vue?vue&type=script&lang=js"

import "./ConsumptionGauges.vue?vue&type=style&index=0&id=530b8367&scoped=true&lang=css"

import exportComponent from "../../../peelochat-dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-530b8367"]])

export default __exports__